import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import Waves from "../../components/atoms/Waves";

export const HeroHome = ({ video }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const vid = videoRef.current;
        if (!vid) return;

        const handleLoadedMetadata = () => {
            try {
                vid.currentTime = 41; // démarre à 21 secondes
            } catch (err) {
                console.warn("Impossible de définir le point de départ :", err);
            }
        };

        vid.addEventListener("loadedmetadata", handleLoadedMetadata);
        return () => {
            vid.removeEventListener("loadedmetadata", handleLoadedMetadata);
        };
    }, [video]);

    return (
        <div className="position-relative overflow-hidden">
            <video
                ref={videoRef}
                data-src-mp4={video}
                autoPlay
                loop
                playsInline
                muted
                style={{
                    position: "absolute",
                    zIndex: "-1",
                    height: "1080px",
                    width: "100%",
                    objectFit: "cover",
                    marginTop: "-200px",
                }}
            >
                <source src={video} type="video/mp4" />
            </video>
            <div className="vitaleu-container-hero-home ripple-effect">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={7} md={10} sm={12} xs={12} className="vitaleau-hero-intro">
                            <h1 className="home" style={{ margin: "0" }}>
                                Bébés nageurs, Natation ou Aquagym...
                                <br />
                                <span>Bienvenue à la piscine !</span>
                            </h1>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <Waves />
        </div>
    );
};

HeroHome.propTypes = {
    video: PropTypes.string.isRequired,
};
